import MgoIcon from '@humanforce/mango-ui/dist/react/icon/index.js';
import { asMangoElement } from './mango';

const MangoIcon = asMangoElement(MgoIcon);

interface IconProps {
  name: string;
  slot?: string;
}

export const Icon = ({ name, slot }: IconProps) => {
  return <MangoIcon name={name} slot={slot} />;
};
